export const SKIPPED_BACKGROUND_AND_CREDIT_VERIFICATION_MSG =
  "Applicant skipped Credit & Background check. No data to display.";

export const INCOME_ASSETS_SKIPPED_REASON = Object.freeze({
  UserRefusedSharingCredentials: "UserRefusedSharingCredentials",
  BankNotFound: "BankNotFound",
  BankError: "BankError",
});
